const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export const getRemainingDays = (endDate: Date, now = new Date()): number =>
  Math.max(
    0,
    Math.ceil((endDate.getTime() - now.getTime()) / MILLISECONDS_PER_DAY)
  );
